<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w29YzQ/tc-custom/9781480439535.jpg?1733105494254" alt="This image is the cover for the book Standard Dreaming"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Standard Dreaming
      </h1>
      <p class="bookDescription body article font2">
        <b>A unique novel of parents and children—and the spaces between them</b><br/>Dr. Niels Berners—a Swiss plastic surgeon living in New York—is struggling to recover from his dysfunctional son’s abandonment of him. He joins a group of four other parents, all with absent children either in jail or in jeopardy, to discuss their feelings and seek a sense of community, comfort, and closure.<br/>Hortense Calisher artfully strings together tales of healing, brilliantly tracing the shadow of the generational gap. With compassion and precision, she paints the bruised egos of concerned parents confronting very empty nests.  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hortense Calisher
      </h2>
      
      <p class="authorDescription body article">Hortense Calisher (1911&ndash;2009) was born in New York City. The daughter of a young German-Jewish immigrant mother and a somewhat older Jewish father from Virginia, she graduated from Barnard College in 1932 and worked as a sales clerk before marrying and moving to Nyack, New York, to raise her family. Her first book, a collection of short stories titled <i>In the Absence of Angels</i>, appeared in 1951. She went on to publish two dozen more works of fiction and memoir, writing into her nineties.A past president of the American Academy of Arts and Letters and of PEN, the worldwide association of writers, she was a National Book Award finalist three times, won an O. Henry Award for &ldquo;The Night Club in the Woods&rdquo; and the 1986 Janet Heidinger Kafka Prize for <i>The Bobby Soxer</i>, and was awarded Guggenheim Fellowships in 1952 and 1955.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36232876